import {makeStyles} from "@material-ui/core/styles";

// Ayarlar ekraninin ortak gorsel dili — SSS / Meta Tag ekranlariyla ayni token'lar:
// kirmizi #d71f26, kenarlik #eaedf3, baslik #2d3748, ikincil metin #8492a6.
// Durum renkleri aksandan ayri tutulur: yesil #157f4f (acik), amber #a86200 (eksik), gri #8a95a5 (kapali).
const settingsStyles = makeStyles((theme) => ({

    // --- Sayfa iskeleti ---
    // Not: dar ekran kurallari 'sm' (<960px) altinda tanimlanir — 600-960 arasi
    // genis telefonlar da tek kolona duser. 'xs' (<600px) yalnizca ek sikilastirma.
    layout: {
        display: 'grid',
        gridTemplateColumns: '214px minmax(0, 1fr)',
        gap: 28,
        alignItems: 'start',
        paddingBottom: 60,
        minWidth: 0,
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
            gap: 14,
            paddingBottom: 40,
        },
    },
    sections: {
        display: 'flex',
        flexDirection: 'column',
        gap: 22,
        minWidth: 0,
        [theme.breakpoints.down('sm')]: {
            gap: 14,
        },
    },
    // Mobilde container yan bosluk birakmadigi icin kartlar kenara yapismasin
    mobilePadding: {
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 14,
            paddingRight: 14,
        },
    },

    // --- Sol bolum menusu ---
    rail: {
        position: 'sticky',
        top: 20,
        [theme.breakpoints.down('sm')]: {
            position: 'static',
        },
    },
    railList: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'row',
            overflowX: 'auto',
            gap: 6,
            padding: '2px 14px 6px',
            marginLeft: -14,
            marginRight: -14,
            WebkitOverflowScrolling: 'touch',
            scrollSnapType: 'x proximity',
            // Yatay kaydirma cubugu mobilde yer kaplamasin
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            '& > li': {
                scrollSnapAlign: 'start',
            },
        },
    },
    railLink: {
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        padding: '9px 12px',
        borderRadius: 8,
        color: '#5b6675',
        textDecoration: 'none',
        fontSize: 13.5,
        fontWeight: 600,
        borderLeft: '2px solid transparent',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        borderLeftWidth: 2,
        borderLeftStyle: 'solid',
        borderLeftColor: 'transparent',
        fontFamily: 'inherit',
        textAlign: 'left',
        width: '100%',
        '& i': {
            fontSize: 15,
            width: 16,
            flexShrink: 0,
            color: '#8492a6',
        },
        '&:hover': {
            background: '#fff',
            color: '#2d3748',
        },
        [theme.breakpoints.down('sm')]: {
            whiteSpace: 'nowrap',
            width: 'auto',
            borderLeft: 'none',
            borderBottom: '2px solid transparent',
            padding: '8px 13px',
            background: '#fff',
            border: '1px solid #eaedf3',
            borderRadius: 999,
        },
    },
    railLinkActive: {
        background: '#fff',
        color: '#d71f26',
        borderLeftColor: '#d71f26',
        boxShadow: '0 1px 3px rgba(45, 55, 72, 0.05)',
        '& i': {
            color: '#d71f26',
        },
        [theme.breakpoints.down('sm')]: {
            borderColor: '#d71f26',
            background: '#fdeced',
        },
    },
    railCount: {
        marginLeft: 'auto',
        fontSize: 11,
        fontWeight: 700,
        color: '#8492a6',
        background: '#eef1f6',
        padding: '1px 7px',
        borderRadius: 999,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 4,
        },
    },
    railCountWarn: {
        color: '#a86200',
        background: '#fdf1de',
    },

    // --- Kart ---
    card: {
        background: '#fff',
        border: '1px solid #eaedf3',
        borderRadius: 16,
        boxShadow: '0 1px 3px rgba(45, 55, 72, 0.05)',
        overflow: 'hidden',
        scrollMarginTop: 20,
    },
    // Header govdeden ayri okunmali: kendi zemini, kalin alt kenarligi ve
    // govde satirlarindan belirgin sekilde daha guclu basligi var.
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '17px 20px',
        background: 'linear-gradient(180deg, #fbfcfe 0%, #f5f8fc 100%)',
        borderBottom: '1px solid #e3e8f1',
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            padding: '14px 16px',
            gap: 12,
        },
    },
    cardHeaderIcon: {
        width: 38,
        height: 38,
        borderRadius: 11,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        border: '1px solid #e6eaf2',
        color: '#d71f26',
        fontSize: 16,
        boxShadow: '0 1px 2px rgba(45, 55, 72, 0.06)',
    },
    cardHeaderText: {
        flex: '1 1 200px',
        minWidth: 0,
    },
    cardTitle: {
        margin: 0,
        fontSize: 16.5,
        fontWeight: 700,
        color: '#1a2332',
        letterSpacing: -0.25,
        lineHeight: 1.25,
    },
    cardDesc: {
        margin: '3px 0 0',
        fontSize: 12.5,
        color: '#8492a6',
        lineHeight: 1.45,
    },
    cardHeaderActions: {
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            width: '100%',
            flexWrap: 'wrap',
            // Baslik ikonu hizasindan devam etsin
            '& > *': {
                flex: '1 1 auto',
            },
        },
    },
    // Baslik yanindaki ozet (orn. "3 bileşen açık") — header'a bilgi yogunlugu katar
    cardHeaderMeta: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 11.5,
        fontWeight: 600,
        color: '#5b6675',
        background: '#fff',
        border: '1px solid #e6eaf2',
        borderRadius: 999,
        padding: '4px 11px',
        whiteSpace: 'nowrap',
    },

    // --- Ayar satiri ---
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 14,
        padding: '16px 20px',
        borderTop: '1px solid #d6d6d6',
        '&:first-child': {
            borderTop: 'none',
        },
        // Dar ekranda kontrol alt satira gecer; ikon + metin genisligi korur
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            padding: '14px 16px',
            gap: 12,
        },
    },
    rowIcon: {
        width: 34,
        height: 34,
        borderRadius: 10,
        flexShrink: 0,
        marginTop: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f7f9fc',
        border: '1px solid #d6d6d6',
        color: '#5b6675',
        fontSize: 15,
    },
    rowIconActive: {
        background: '#e6f4ec',
        borderColor: 'transparent',
        color: '#157f4f',
    },
    rowBody: {
        flex: '1 1 auto',
        minWidth: 0,
        [theme.breakpoints.down('sm')]: {
            // ikon (34) + gap (12) kadar yer birak, kalan genisligi kapla
            flexBasis: 'calc(100% - 46px)',
        },
    },
    // Satir basligi bilerek header basligindan hafif: hiyerarsi kart > satir
    rowTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        fontWeight: 600,
        fontSize: 13.5,
        color: '#2d3748',
    },
    rowDesc: {
        margin: '3px 0 0',
        fontSize: 12.75,
        color: '#8492a6',
        lineHeight: 1.45,
    },
    rowControl: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        paddingTop: 2,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            justifyContent: 'flex-end',
            paddingTop: 0,
            // Butonlar dokunma hedefi olarak yeterince genis olsun
            '& .MuiButton-root': {
                minHeight: 40,
            },
        },
    },

    // --- Satir alti ayrinti paneli ---
    subPanel: {
        marginTop: 12,
        padding: '12px 14px',
        background: '#f7f9fc',
        border: '1px solid #d6d6d6',
        borderRadius: 12,
        display: 'grid',
        gap: 10,
    },
    // Satir altindaki alt secenek (uclu butonun her bir dugmesi gibi)
    subToggleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '6px 0',
        borderTop: '1px solid #eef1f6',
        '&:first-child': {
            borderTop: 'none',
            paddingTop: 0,
        },
    },
    subToggleLabel: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 9,
        flex: '1 1 auto',
        fontSize: 13,
        fontWeight: 600,
        color: '#2d3748',
        '& i': {
            width: 16,
            fontSize: 14,
            color: '#8492a6',
            textAlign: 'center',
        },
    },

    // Alan + kendi kaydet butonu yan yana; dar ekranda alt alta.
    // Buton karttaki diger butonlarla ayni yukseklikte kalir ve alanin
    // dikey ortasina hizalanir (stretch alanin boyuna uzatiyordu).
    inlineField: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 0,
        '& .MuiButton-root': {
            flexShrink: 0,
            alignSelf: 'center',
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            '& .MuiButton-root': {
                alignSelf: 'stretch',
                marginTop: 0,
            },
        },
    },
    subGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 10,
        minWidth: 0,
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
        },
    },
    hint: {
        fontSize: 12,
        color: '#8492a6',
        lineHeight: 1.5,
        margin: 0,
    },

    // --- Google yorum ozeti ---
    reviewSummary: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
    },
    reviewScore: {
        fontSize: 17,
        fontWeight: 700,
        color: '#2d3748',
        lineHeight: 1,
    },
    reviewStars: {
        display: 'inline-flex',
        gap: 2,
        color: '#fbbc04',
        fontSize: 13,
    },
    reviewTotal: {
        fontSize: 12.5,
        color: '#8492a6',
    },
    reviewSpacer: {
        flex: '1 1 auto',
    },

    // --- Channex kontenjan senkron ozeti ---
    channexInventory: {
        display: 'grid',
        gap: 10,
        padding: '12px 13px',
        background: '#fff',
        border: '1px solid #e6eaf2',
        borderRadius: 12,
    },
    channexInventoryHead: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        fontSize: 13,
        fontWeight: 700,
        color: '#2d3748',
        '& > i': {
            fontSize: 13,
            color: '#8492a6',
        },
    },
    channexInventoryPills: {
        marginLeft: 'auto',
        display: 'inline-flex',
        gap: 6,
        flexWrap: 'wrap',
    },

    // Baglanti ayrintilarinda kucuk etiket/deger ikilisi
    metaLabel: {
        display: 'block',
        fontSize: 11,
        fontWeight: 650,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
        color: '#8492a6',
        marginBottom: 3,
    },
    metaValue: {
        display: 'block',
        fontSize: 13,
        fontWeight: 600,
        color: '#2d3748',
        wordBreak: 'break-all',
    },

    // Aktif ucuncu parti etiketlerinin listesi
    tagList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 7,
    },
    tagChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        fontWeight: 600,
        color: '#2d3748',
        background: '#fff',
        border: '1px solid #e6eaf2',
        borderRadius: 999,
        padding: '4px 11px',
        '& i': {
            fontSize: 9,
            color: '#157f4f',
        },
    },

    // --- Durum rozeti ---
    pill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.2,
        padding: '3px 9px',
        borderRadius: 999,
        whiteSpace: 'nowrap',
        lineHeight: 1.6,
    },
    pillDot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: 'currentColor',
        display: 'block',
    },
    pillOk: {background: '#e6f4ec', color: '#157f4f'},
    pillWarn: {background: '#fdf1de', color: '#a86200'},
    pillOff: {background: '#eef1f6', color: '#8a95a5'},
    pillBrand: {background: '#fdeced', color: '#d71f26'},

    // --- Butonlar ---
    btn: {
        fontSize: 13,
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: 8,
        padding: '7px 14px',
        border: '1px solid #eaedf3',
        background: '#fff',
        color: '#2d3748',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        '&:hover': {
            background: '#f7f9fc',
            boxShadow: 'none',
        },
    },
    btnPrimary: {
        background: 'linear-gradient(135deg, #d71f26 0%, #e8484f 100%)',
        borderColor: 'transparent',
        color: '#fff !important',
        '&:hover': {
            background: 'linear-gradient(135deg, #c31a20 0%, #d93f46 100%)',
        },
    },
    btnDanger: {
        color: '#d71f26',
        '&:hover': {
            background: '#fdeced',
        },
    },
    linkish: {
        color: '#d71f26',
        fontWeight: 600,
        fontSize: 12.5,
        textDecoration: 'none',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    // Opsiyonel alanlarin eylemi: davet eder ama uyari gibi durmaz
    linkishMuted: {
        color: '#8492a6',
        fontWeight: 600,
        fontSize: 12.5,
        textDecoration: 'none',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        '&:hover': {
            color: '#5b6675',
            textDecoration: 'underline',
        },
    },

    // --- Bilgi doğruluk oranı ---
    health: {
        display: 'grid',
        gridTemplateColumns: '214px minmax(0, 1fr)',
        gap: 24,
        padding: 20,
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
            gap: 18,
            padding: 16,
        },
    },
    // Dar ekranda halka ve aciklama yan yana durur, dikey yer harcamaz
    gauge: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 16,
            textAlign: 'left',
        },
    },
    ring: {
        width: 158,
        height: 158,
        flexShrink: 0,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 13,
            right: 13,
            bottom: 13,
            left: 13,
            borderRadius: '50%',
            background: '#fff',
        },
        // Media query base kurallardan SONRA gelmeli, yoksa ayni ozgullukte ezilir
        [theme.breakpoints.down('sm')]: {
            width: 104,
            height: 104,
            '&::before': {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10,
            },
        },
    },
    ringValue: {
        position: 'relative',
        textAlign: 'center',
    },
    ringNumber: {
        display: 'block',
        fontSize: 38,
        fontWeight: 700,
        letterSpacing: -1,
        lineHeight: 1,
        color: '#2d3748',
        fontVariantNumeric: 'tabular-nums',
        [theme.breakpoints.down('sm')]: {
            fontSize: 27,
        },
    },
    ringLabel: {
        fontSize: 10.5,
        letterSpacing: 1,
        textTransform: 'uppercase',
        color: '#8492a6',
        fontWeight: 700,
    },
    gaugeCaption: {
        fontSize: 12.5,
        color: '#8492a6',
        textAlign: 'center',
        maxWidth: 190,
        lineHeight: 1.5,
        margin: 0,
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
            maxWidth: 'none',
        },
    },
    checkGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(268px, 1fr))',
        gap: '2px 20px',
        alignContent: 'start',
        minWidth: 0,
        // 268px'lik minimum dar ekranda tasmaya yol aciyordu; tek kolona duser
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
        },
    },
    check: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 0',
        borderBottom: '1px solid #d6d6d6',
    },
    checkMark: {
        width: 18,
        height: 18,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontSize: 9,
    },
    checkMarkDone: {background: '#e6f4ec', color: '#157f4f'},
    checkMarkPartial: {background: '#fdf1de', color: '#a86200'},
    checkMarkMissing: {background: '#eef1f6', color: '#8a95a5'},
    checkName: {
        fontSize: 13,
        fontWeight: 600,
        color: '#2d3748',
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    checkNameMissing: {
        color: '#5b6675',
        fontWeight: 500,
    },
    checkStatus: {
        marginLeft: 'auto',
        paddingLeft: 10,
        fontSize: 12,
        color: '#8492a6',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    checkAction: {
        marginLeft: 'auto',
    },

    // --- Yayin durumu bandi ---
    publish: {
        display: 'flex',
        alignItems: 'center',
        gap: 18,
        padding: '18px 20px',
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            padding: '16px',
            gap: 14,
        },
    },
    publishState: {
        display: 'flex',
        alignItems: 'center',
        gap: 13,
        minWidth: 0,
    },
    beacon: {
        width: 42,
        height: 42,
        borderRadius: 12,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 17,
    },
    beaconLive: {background: '#e6f4ec', color: '#157f4f'},
    beaconOff: {background: '#eef1f6', color: '#8a95a5'},
    beaconWait: {background: '#fdf1de', color: '#a86200'},
    publishTitle: {
        margin: 0,
        fontSize: 15,
        fontWeight: 700,
        color: '#2d3748',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
    },
    publishDesc: {
        margin: '2px 0 0',
        fontSize: 12.5,
        color: '#8492a6',
    },
    publishActions: {
        marginLeft: 'auto',
        display: 'flex',
        gap: 9,
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            width: '100%',
            // Iki buton esit genislikte, tam dokunma hedefi
            '& > *': {
                flex: '1 1 140px',
                minHeight: 42,
            },
            '& .MuiButton-root': {
                width: '100%',
                minHeight: 42,
            },
        },
    },

    // --- Dialog ---
    // Mobilde varsayilan 32px kenar bosluğu dar ekranda cok yer yiyor
    dialogPaper: {
        [theme.breakpoints.down('xs')]: {
            margin: 12,
            width: 'calc(100% - 24px)',
            maxWidth: 'calc(100% - 24px)',
            maxHeight: 'calc(100% - 24px)',
        },
    },
    dialogHead: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '18px 24px 16px',
        borderBottom: '2px solid #d71f26',
        [theme.breakpoints.down('xs')]: {
            padding: '14px 16px 12px',
        },
    },
    dialogTitle: {
        fontWeight: 700,
        fontSize: 18,
        color: '#1a2332',
        letterSpacing: -0.3,
        lineHeight: 1.3,
    },
    dialogSub: {
        margin: '4px 0 0',
        fontSize: 12.5,
        color: '#8492a6',
        lineHeight: 1.45,
    },
    dialogClose: {
        marginLeft: 'auto',
        marginTop: -4,
        color: '#9ca3af',
        padding: 8,
    },
    dialogFoot: {
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        padding: '14px 24px',
        borderTop: '1px solid #d6d6d6',
        background: '#fbfcfe',
        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
            padding: '12px 16px',
            '& .MuiButton-root': {
                flex: '1 1 auto',
                minHeight: 42,
                margin: 0,
            },
        },
    },
    dialogFootNote: {
        fontSize: 12.5,
        color: '#8492a6',
        marginRight: 'auto',
        [theme.breakpoints.down('xs')]: {
            // Mobilde not butonlarin ustune gecer, yer daraltmaz
            flex: '1 1 100%',
            marginRight: 0,
            marginBottom: 4,
        },
    },

    // --- Tablo ---
    tableWrap: {
        overflowX: 'auto',
    },
    // Uzun listelerde baslik satiri gorunur kalir
    thSticky: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
    // Yeni oda grubunun ilk satirini ayiran daha belirgin cizgi
    trGroupStart: {
        '& td': {
            borderTop: '1px solid #e3e8f1',
        },
    },
    // Oda adi hucresi birden fazla satiri kapsar (rowSpan); adin gruba ait oldugu
    // hucre yuksekliginden anlasilir, ust hizada durur.
    tdRoom: {
        verticalAlign: 'top',
        borderRight: '1px solid #d6d6d6',
    },
    gapRoomName: {
        display: 'block',
        fontWeight: 600,
        color: '#2d3748',
        maxWidth: 260,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    // Odanin kac ayri donemi oldugunu belirtir (yalnizca birden fazlaysa)
    gapRoomCount: {
        display: 'block',
        marginTop: 3,
        fontSize: 11.5,
        color: '#8492a6',
        fontWeight: 500,
    },
    wholeRangeTag: {
        marginLeft: 7,
        fontSize: 11,
        color: '#a86200',
        fontWeight: 600,
    },

    // --- Kontenjan listesi: dar ekran gorunumu (tablo yerine) ---
    gapCardList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: '10px 16px 16px',
    },
    gapCard: {
        border: '1px solid #eaedf3',
        borderRadius: 12,
        overflow: 'hidden',
        background: '#fff',
    },
    gapCardRoom: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 8,
        padding: '10px 13px',
        background: '#f7f9fc',
        borderBottom: '1px solid #d6d6d6',
        fontSize: 13.5,
        fontWeight: 700,
        color: '#2d3748',
        lineHeight: 1.35,
    },
    gapCardRoomDays: {
        marginLeft: 'auto',
        flexShrink: 0,
        fontSize: 12,
        fontWeight: 600,
        color: '#a86200',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    gapCardItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexWrap: 'wrap',
        padding: '10px 13px',
        borderTop: '1px solid #f6f8fb',
        '&:first-child': {
            borderTop: 'none',
        },
    },
    gapCardDate: {
        fontSize: 13,
        fontWeight: 600,
        color: '#2d3748',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    gapCardMeta: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        marginLeft: 'auto',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
    },
    gapCardDays: {
        fontSize: 12.5,
        color: '#8492a6',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: 13,
        // Global "tr:nth-child(even)" zebrasi burada kapatilir: rowSpan ile gruplanan
        // satirlar farkli renklere dusup gruplama gorunumunu bozuyordu.
        '& tbody tr:nth-child(even)': {
            backgroundColor: 'transparent',
        },
        '& tbody tr:hover': {
            backgroundColor: '#fbfcfe',
        },
    },
    th: {
        textAlign: 'left',
        fontSize: 10.5,
        letterSpacing: 0.8,
        textTransform: 'uppercase',
        color: '#8492a6',
        fontWeight: 700,
        padding: '9px 20px',
        background: '#f7f9fc',
        borderTop: '1px solid #d6d6d6',
        borderBottom: '1px solid #d6d6d6',
        whiteSpace: 'nowrap',
        // Son sutun sag kenara yapismasin
        '&:last-child': {
            paddingRight: 40,
        },
    },
    td: {
        padding: '11px 20px',
        borderBottom: '1px solid #d6d6d6',
        borderRight: '1px solid #d6d6d6',
        verticalAlign: 'middle',
        color: '#2d3748',
        '&:last-child': {
            paddingRight: 48,
        },
    },
    tdMuted: {
        color: '#5b6675',
        fontVariantNumeric: 'tabular-nums',
    },

    // --- Tema kartlari ---
    themeGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(168px, 1fr))',
        gap: 14,
        padding: '18px 20px',
        [theme.breakpoints.down('sm')]: {
            // Telefonda iki kolon: onizleme gorseli hala secilebilir buyuklukte kalir
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 10,
            padding: '16px',
        },
    },
    themeCard: {
        border: '3px solid #eaedf3',
        borderRadius: 12,
        overflow: 'hidden',
        background: '#f7f9fc',
        cursor: 'pointer',
        textAlign: 'left',
        padding: 0,
        fontFamily: 'inherit',
        color: 'inherit',
        position: 'relative',
        display: 'block',
        width: '100%',
    },
    themeCardActive: {
        borderColor: '#d71f26',
        boxShadow: '0 0 0 3px #fdeced',
    },
    themeShot: {
        display: 'block',
        width: '100%',
        aspectRatio: '4 / 3',
        objectFit: 'cover',
        background: '#eef1f6',
    },
    themeName: {
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        padding: '9px 11px',
        fontSize: 13,
        fontWeight: 600,
        color: '#2d3748',
        borderTop: '1px solid #d6d6d6',
        background: '#fff',
    },
    themeNameActive: {
        color: '#d71f26',
    },
    themeCurrent: {
        marginLeft: 'auto',
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: 0.5,
        color: '#d71f26',
    },

    // --- Kontenjan ---
    alertBar: {
        display: 'flex',
        alignItems: 'center',
        gap: 13,
        padding: '14px 20px',
        background: '#fdf1de',
        borderBottom: '1px solid #d6d6d6',
        '& i': {
            fontSize: 17,
            color: '#a86200',
            flexShrink: 0,
        },
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            padding: '14px 16px',
            gap: 10,
            // Buton alt satirda tam genislik alir
            '& .MuiButton-root': {
                marginLeft: '0 !important',
                width: '100%',
                minHeight: 40,
            },
        },
    },
    alertText: {
        margin: 0,
        fontSize: 13,
        color: '#2d3748',
        lineHeight: 1.5,
        minWidth: 0,
        [theme.breakpoints.down('sm')]: {
            flex: '1 1 calc(100% - 30px)',
        },
    },
    gapList: {
        display: 'grid',
        gap: 10,
        padding: '16px 20px',
    },
    // Dar ekranda oda adi ustte, cubuk ve gun sayisi altta: uzun oda adlari
    // sabit kolona sigmadigi icin tasma yapiyordu.
    gapLine: {
        display: 'grid',
        gridTemplateColumns: '152px minmax(0, 1fr) 74px',
        gap: 12,
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: 'minmax(0, 1fr) auto',
            gridTemplateAreas: '"name days" "track track"',
            gap: '4px 10px',
        },
    },
    gapRoom: {
        fontSize: 13,
        fontWeight: 600,
        color: '#2d3748',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.down('sm')]: {
            gridArea: 'name',
        },
    },
    gapTrack: {
        height: 9,
        borderRadius: 999,
        background: '#d6d6d6',
        overflow: 'hidden',
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            gridArea: 'track',
            height: 8,
        },
    },
    gapFull: {background: '#157f4f', height: '100%', display: 'block'},
    gapEmpty: {background: '#a86200', height: '100%', display: 'block'},
    gapCount: {
        fontSize: 12,
        color: '#8492a6',
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            gridArea: 'days',
        },
    },
    legend: {
        display: 'flex',
        gap: 16,
        padding: '0 20px 16px',
        fontSize: 12,
        color: '#8492a6',
    },
    legendItem: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
    },
    legendSwatch: {
        width: 9,
        height: 9,
        borderRadius: 3,
        display: 'block',
    },

    // --- Yukleniyor ---
    loadingBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(6, 3),
    },
}));

export default settingsStyles;
